import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE, readCachedLanguage } from "~/i18n/languagePreference";
import { DEFAULT_NAMESPACE, NAMESPACES } from "~/locales/namespaces";
import resources from "~/locales/resources";

if (!i18n.isInitialized) {
	i18n.use(initReactI18next).init({
		resources,
		lng: readCachedLanguage(),
		fallbackLng: DEFAULT_LANGUAGE,
		ns: NAMESPACES,
		defaultNS: DEFAULT_NAMESPACE,
		supportedLngs: ["en", "es"],
		interpolation: { escapeValue: false },
		react: { useSuspense: false },
		returnNull: false
	});
}

export default i18n;
